// source: pbtypes/gen/scan_planner/single_orbit_request.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_eigen_lcm_Vector3d_pb = require('../../../pbtypes/gen/eigen_lcm/Vector3d_pb.js');
goog.object.extend(proto, pbtypes_gen_eigen_lcm_Vector3d_pb);
goog.exportSymbol('proto.scan_planner.SingleOrbitRequest', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.scan_planner.SingleOrbitRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.scan_planner.SingleOrbitRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.scan_planner.SingleOrbitRequest.displayName = 'proto.scan_planner.SingleOrbitRequest';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.scan_planner.SingleOrbitRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.scan_planner.SingleOrbitRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.scan_planner.SingleOrbitRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scan_planner.SingleOrbitRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
radius: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
globalMapTCenter: (f = msg.getGlobalMapTCenter()) && pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb.toObject(includeInstance, f),
gimbalPitch: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
numPhotos: jspb.Message.getFieldWithDefault(msg, 4, 0),
lookOutwards: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
counterClockwise: jspb.Message.getBooleanFieldWithDefault(msg, 6, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.scan_planner.SingleOrbitRequest}
 */
proto.scan_planner.SingleOrbitRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.scan_planner.SingleOrbitRequest;
  return proto.scan_planner.SingleOrbitRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.scan_planner.SingleOrbitRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.scan_planner.SingleOrbitRequest}
 */
proto.scan_planner.SingleOrbitRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRadius(value);
      break;
    case 2:
      var value = new pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb;
      reader.readMessage(value,pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb.deserializeBinaryFromReader);
      msg.setGlobalMapTCenter(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setGimbalPitch(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setNumPhotos(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setLookOutwards(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCounterClockwise(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.scan_planner.SingleOrbitRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.scan_planner.SingleOrbitRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.scan_planner.SingleOrbitRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scan_planner.SingleOrbitRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRadius();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getGlobalMapTCenter();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb.serializeBinaryToWriter
    );
  }
  f = message.getGimbalPitch();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getNumPhotos();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getLookOutwards();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getCounterClockwise();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
};


/**
 * optional double radius = 1;
 * @return {number}
 */
proto.scan_planner.SingleOrbitRequest.prototype.getRadius = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.scan_planner.SingleOrbitRequest} returns this
 */
proto.scan_planner.SingleOrbitRequest.prototype.setRadius = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional eigen_lcm.Vector3dPb global_map_t_center = 2;
 * @return {?proto.eigen_lcm.Vector3dPb}
 */
proto.scan_planner.SingleOrbitRequest.prototype.getGlobalMapTCenter = function() {
  return /** @type{?proto.eigen_lcm.Vector3dPb} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb, 2));
};


/**
 * @param {?proto.eigen_lcm.Vector3dPb|undefined} value
 * @return {!proto.scan_planner.SingleOrbitRequest} returns this
*/
proto.scan_planner.SingleOrbitRequest.prototype.setGlobalMapTCenter = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.scan_planner.SingleOrbitRequest} returns this
 */
proto.scan_planner.SingleOrbitRequest.prototype.clearGlobalMapTCenter = function() {
  return this.setGlobalMapTCenter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.scan_planner.SingleOrbitRequest.prototype.hasGlobalMapTCenter = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional double gimbal_pitch = 3;
 * @return {number}
 */
proto.scan_planner.SingleOrbitRequest.prototype.getGimbalPitch = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.scan_planner.SingleOrbitRequest} returns this
 */
proto.scan_planner.SingleOrbitRequest.prototype.setGimbalPitch = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional uint32 num_photos = 4;
 * @return {number}
 */
proto.scan_planner.SingleOrbitRequest.prototype.getNumPhotos = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.scan_planner.SingleOrbitRequest} returns this
 */
proto.scan_planner.SingleOrbitRequest.prototype.setNumPhotos = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional bool look_outwards = 5;
 * @return {boolean}
 */
proto.scan_planner.SingleOrbitRequest.prototype.getLookOutwards = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.scan_planner.SingleOrbitRequest} returns this
 */
proto.scan_planner.SingleOrbitRequest.prototype.setLookOutwards = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional bool counter_clockwise = 6;
 * @return {boolean}
 */
proto.scan_planner.SingleOrbitRequest.prototype.getCounterClockwise = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.scan_planner.SingleOrbitRequest} returns this
 */
proto.scan_planner.SingleOrbitRequest.prototype.setCounterClockwise = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


goog.object.extend(exports, proto.scan_planner);
